import { parseDo } from "../../../../Score/methods/changeDo";
import getKeyOffset from "../../Common/getKeyOffset";
import { getNoteOffset } from "../../../../../../common/parameters";
import { IDoPos, IParsedDo, IPitch } from "../../../../../../common/types";
import {
    pianoParser,
} from "../../../../../../common/parameters";
import { IProps } from "./interfaces";

interface IGetPitchProps {
    doPos: IDoPos,
    doOctave: number
    index: number,
}

export const getPitch = ({ doPos, doOctave, index }: IGetPitchProps) => {
    const doPosParsed = parseDo(doPos);
    const keyOffset = getKeyOffset(doPosParsed.value + 6) + doPosParsed.alt;
    let noteOffset = index - (keyOffset + 60);
    // Octave
    let o = 0;
    if (noteOffset < -12) o = -2;
    else if (noteOffset < 0) o = -1;
    if (noteOffset > 11) o = 1;
    if (noteOffset === 24) o = 2;
    o -= doOctave || 0;
    let { s, a } = getNoteOffset((noteOffset + 36) % 12);
    return { o: o as IPitch["o"], s, a };
};


export const getSelectedNote = (pitch: IPitch | IPitch[], doPos: IDoPos | IParsedDo, voiceO: number) => {
    const pitches = Array.isArray(pitch) ? pitch : [pitch];
    return pitches.map(({ s, a, o }) => {
        const doPosParsed = (doPos as IParsedDo).value !== undefined ? (doPos as IParsedDo) : parseDo(doPos as IDoPos);
        return (
            60 +
            pianoParser[s] +
            (a || 0) +
            getKeyOffset(doPosParsed.value + 6) +
            doPosParsed.alt +
            ((o || 0) + voiceO) * 12
        );
    });
};

export const getHintNote = ({ score, hint, currentNote, activeVoice, doPos }: IProps) => {
    if (!hint) return null;
    return getSelectedNote(currentNote!.p!, doPos!, score["octave" + (activeVoice || "0")] || 0);
};

